export const GET_FILES_MATTERS_REQUEST = "GET_FILES_MATTERS_REQUEST";
export const GET_FILES_MATTERS_SUCCESS = "GET_FILES_MATTERS_SUCCESS";
export const GET_FILES_MATTERS_FAIL = "GET_FILES_MATTERS_FAIL";
export const GET_FILES_MATTERS_RESET = "GET_FILES_MATTERS_RESET";